<form [formGroup]="questionariObservacionsForm"> 

  <div *ngIf="!simulacio.teAlgunaObservacio" class="enblanc">
    {{'questionari_observacions.en_blanc' | translate}}
  </div>
  <div *ngIf="simulacio.teAlgunaObservacio" class="questionari">
    <div class="part esquerra">
      <app-accordion individual="true">
        <label><span>Cerca ràpida:</span> <input type="search" formControlName="filtre" style="width: 60%"></label>
        <i class="far fa-plus-square clicable" (click)="expandir()" title="Expandir l'arbre"></i>
        <i class="far fa-minus-square clicable" (click)="colapsar()" title="Contraure l'arbre"></i>
        <app-ajuda id="ajuda_blocs" titol="{{'questionari_observacions.ajuda_label_blocs' | translate}}">
          Tot seguit us apareix la llista d'observacions agrupades en cinc grans blocs:
  
          <ul>
            <li>Els tres primers blocs contenen les observacions que es poden destacar de l'infant o adolescent, tant del seu aspecte físic (higiene, alimentació, lesions, etc.) com la seva situació personal, emocional o conductual, o bé relatives a l'àrea escolar.</li>
            <li>El quart bloc es refereix a les relacions i actituds dels progenitors o guardadors envers l'infant/adolescent.</li>
            <li>En el cinquè bloc, hi trobareu observacions sobre les dades del context actual de l'infant i de la seva família, així com algunes dades relatives a situacions que s'han produït en el passat i que poden ser rellevants de conèixer en el moment actual.</li>
          </ul>
          Tingueu en compte que el sistema valora el risc o el maltractament dins de l'àmbit familiar i, principalment, ha de recollir observacions sobre el moment actual de l'infant o adolescent, i que preocupen no sols per la seva intensitat, sinó també per la seva recurrència, és a dir, no s'han de fer observacions aïllades o anecdòtiques.
          Dins de cada bloc es mostren uns <strong>conjunts d'observacions.</strong> Seleccioneu només aquelles que reflecteixen la situació de l'infant/adolescent al qual us referiu (en una altra pantalla valorareu si les observacions són lleus, moderades o greus). Per visualitzar del tot els conjunts i les observacions, engrandiu la part dreta o esquerra de la pantalla utilitzant el separador central (|||).
          Perquè el programa informàtic us doni un resultat, caldrà marcar com a mínim alguna observació sobre l'infant/adolescent (A, B o C) i alguna sobre els progenitors o guardadors (D, E1, E2 o E3).
  
        </app-ajuda>   
        <ng-container *ngFor="let bloc of simulacio.blocs">
          <app-panel *ngIf="bloc.conjunts.length && teConjuntsAmbFiltre(bloc)" [title]="bloc.descripcio" [opened]="bloc.opened"
            (toggle)="bloc.opened = !bloc.opened">
            <ul class="conjunt">
              <ng-container *ngFor="let conjunt of bloc.conjunts">
                <li *ngIf="conjunt.descripcio.includes(questionariObservacionsForm.value.filtre)" (click)="marca(bloc, conjunt)">
                  <p><label [innerHTML]="senyalarTextFiltre(conjunt.descripcio)"></label></p>
                  <ul>
                    <li *ngFor="let observacio of conjunt.observacions"><p><span>{{observacio.descripcio}}</span></p></li>
                  </ul>
                </li>
              </ng-container>
            </ul>
          </app-panel>
        </ng-container>
      </app-accordion>
    </div>
    <div class="part dreta">
      <ng-container *ngIf="conjuntSeleccionat">
        <label>{{blocSeleccionat.descripcio}}</label>
        <fieldset>
          <legend>{{conjuntSeleccionat.descripcio}} 
            <app-ajuda id="ajuda_observacions_disponibles" titol="{{'questionari_observacions.ajuda_label_observacions_disponibles' | translate}}">
              {{'questionari_observacions.ajuda_observacions_disponibles' | translate}}
              <ul>
                <li>Per seleccionar elements no correlatius: mantenir premuda la tecla Ctrl i fer clic en els elements que desitgeu seleccionar.</li>
                <li>Per seleccionar elements correlatius: mantenir premuda la tecla Shift. Clicar el primer element i després l'últim.</li>
                <li>Per desseleccionar: mantenir premuda la tecla Ctrl i fer clic en els elements que desitgeu desseleccionar.</li>
              </ul>  
            </app-ajuda>
            </legend>        
          <select formControlName="observacions_disponibles" multiple style="width: 100%">
            <option *ngFor="let observacio of conjuntSeleccionat.observacionsDisponibles" [value]="observacio.id" [title]="observacio.descripcio">{{observacio.descripcio}}</option>
          </select>
        </fieldset>
        <div class="row centrat">
          <button (click)="seleccionar()">
            <i class="fas fa-arrow-down"></i>
          </button>
          <button (click)="deseleccionar()">
            <i class="fas fa-arrow-up"></i>
          </button>
        </div>
        <fieldset>
          <legend>{{'questionari_observacions.observacions_seleccionades' | translate}}
            <app-ajuda id="ajuda_observacions_seleccionades" titol="{{'questionari_observacions.ajuda_label_observacions_seleccionades' | translate}}">
              {{'questionari_observacions.ajuda_observacions_seleccionades' | translate}}
              <ul>
                <li>Per seleccionar elements no correlatius: mantenir premuda la tecla Ctrl i fer clic en els elements que desitgeu seleccionar.</li>
                <li>Per seleccionar elements correlatius: mantenir premuda la tecla Shift. Clicar el primer element i després l'últim.</li>
                <li>Per desseleccionar: mantenir premuda la tecla Ctrl i fer clic en els elements que desitgeu desseleccionar.</li>
              </ul>
              </app-ajuda>
            </legend>        
          <select formControlName="observacions_seleccionades" multiple style="width: 100%">
            <option *ngFor="let observacio of conjuntSeleccionat.observacions" [value]="observacio.id" [title]="observacio.descripcio">
              {{observacio.descripcio}}
            </option>
          </select>
        </fieldset>
        <fieldset>        
          <legend>{{'questionari_observacions.noves_observacions_proposades' | translate}}
            <app-ajuda id="ajuda_observacions_proposades" titol="{{'questionari_observacions.ajuda_label_observacions_proposades' | translate}}">
              {{'questionari_observacions.ajuda_observacions_proposades' | translate}}
          </app-ajuda>
        </legend>
          
          <div class="row">
            <select formControlName="observacions_proposades" multiple style="width: 60%">
              <option *ngFor="let observacio of conjuntSeleccionat.observacionsProposades" [value]="observacio.id">{{observacio.descripcio}}
              </option>
            </select>
            <button (click)="eliminar_observacions_proposades_seleccionades()">Eliminar</button>          
          </div>
          <div class="row">
            <input type="text" formControlName="nova_observacio_proposada" style="width: 60%">
            <button (click)="afegir_observacio_proposada()">{{'questionari_observacions.afegir_observacio' | translate}}</button>
          </div>
        </fieldset>
      </ng-container>
    </div>
  </div>
</form>
<div class="button-bar">
  <button class="main" (click)="confirm.open('pestanya-anterior')"><i class="fas fa-angle-left prev" aria-hidden></i> {{'globals.anterior'
    | translate}}</button>
  <button class="main" (click)="goToNextStep()" [disabled]="simulacio.blocs.length==0">{{'globals.seguent' | translate}} <i
      class="fas fa-angle-right next" aria-hidden></i></button>
</div>

<app-confirm id="pestanya-anterior" text="{{'questionari_observacions.confirm_pestanya_anterior' | translate}}" (accept)="goToPrevStep()"></app-confirm>

<vn-modal id="errors" title="{{'globals.revisar_camps' | translate}}" movible>
  <ng-container>{{'questionari_observacions.alguna_observacio' | translate}}</ng-container>
  <div class="button-bar">
    <button type="button" class="main" (click)="modal.close()">{{'globals.tancar' | translate}}</button>
  </div>
</vn-modal>